import React from 'react';

import ProgAnalisisDetail from 'components/Tvendo/Reports/AnalisisProgramming/Detail/Show';

export default function () {
  return <ProgAnalisisDetail />;
}